import { render, staticRenderFns } from "./ac-rating-bar.vue?vue&type=template&id=44dca90d&"
import script from "./ac-rating-bar.vue?vue&type=script&lang=js&"
export * from "./ac-rating-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports